import type { WeddingVideo } from '../types/thankYou'

export const weddingVideos: WeddingVideo[] = [
  { id: 'J2GnuudnqM4', couple: 'Kathleen & Alex' },
  { id: 'QRy1bJnkDjc', couple: 'Allison & Ryan' },
  { id: '3L6Gtms12fQ', couple: 'Nathalie & Lucas' },
  { id: '8-t47Xpnz0E', couple: 'Olivia & Brandon' },
  { id: '20OcM1KpngE', couple: 'Jasmine & Mark' },
  { id: 'Z9KtQUiyrL0', couple: 'Sarah & Aaron' },
  { id: 'SWCMEuQg9qM', couple: 'Mackenzie & Jonathan' },
  { id: 'jXaSqyDnPKY', couple: 'Hailey & Andrew' },
  { id: 'OKuPMQSUS14', couple: 'Lindsey & Robert' },
]
